.list {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}
.list .title {
  font-size: 16px;
  font-weight: 600;
}
.list .sepTitle {
  margin-top: 8px;
}
.list .section .entry {
  margin: none;
  display: block;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIk9yaWdpbnNJbmZvLnNhc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBO0VBQ0E7O0FBQ0E7RUFDRTtFQUNBOztBQUNGO0VBQ0U7O0FBRUE7RUFDRTtFQUNBIiwic291cmNlc0NvbnRlbnQiOlsiLmxpc3RcbiAgZGlzcGxheTogZmxleFxuICBmbGV4LWRpcmVjdGlvbjogY29sdW1uXG4gIGZsZXgtd3JhcDogbm93cmFwXG4gIC50aXRsZVxuICAgIGZvbnQtc2l6ZTogMTZweFxuICAgIGZvbnQtd2VpZ2h0OiA2MDBcbiAgLnNlcFRpdGxlXG4gICAgbWFyZ2luLXRvcDogOHB4XG4gIC5zZWN0aW9uXG4gICAgLmVudHJ5XG4gICAgICBtYXJnaW46IG5vbmVcbiAgICAgIGRpc3BsYXk6IGJsb2NrXG5cbiJdfQ== */